import script from "./ViewMyAppointmentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMyAppointmentDialog.vue?vue&type=script&setup=true&lang=js"

import "./ViewMyAppointmentDialog.vue?vue&type=style&index=0&id=6ac70412&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac70412"]])

export default __exports__